import { Input } from "@/components/podkit/forms/Input";
import { Search } from "lucide-react";
import type { FC } from "react";

type ArchivedEnvironmentSearchInputProps = {
    searchValue?: string;
    disabled?: boolean;
    setSearchValue: (value: string) => void;
};

export const ArchivedEnvironmentSearchInput: FC<ArchivedEnvironmentSearchInputProps> = ({
    searchValue,
    disabled,
    setSearchValue,
}) => {
    return (
        <label className="relative flex w-full">
            <span className="sr-only">Search archived environments</span>

            <Search className="absolute left-[12px] top-[11px] z-10 text-content-tertiary" size={14} />
            <Input
                placeholder={disabled ? "Nothing archived" : "Search archived environments"}
                className="w-full max-w-none pl-8"
                value={searchValue || ""}
                onChange={(e) => setSearchValue(e.target.value.trimStart().replace(/\s+/g, " "))}
                disabled={disabled}
            />
        </label>
    );
};
